<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Reopen Request
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        v-if="checkPermission('app_infor:b2b_inbound_asn_reopen_create')"
        small
        @click="$router.push('/addrequest/0')"
        class="mr-6"
        >Add Request</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4 mr-6"></v-divider>
    <v-data-table
      :headers="headers"
      :items="requestOrder"
      :options.sync="options"
      :server-items-length="total"
      :loading="requestOrderLoader"
      class="elevation-1 custom-icon-size mr-6"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                  @change="fetchClientList(warehouse_id)"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @change="getStores()"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  item-text="channel_name"
                  item-value="id"
                  :items="stores"
                  outlined
                  @change="getReceiptNumber"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  v-model="receipt_key_display"
                  label="Receipt No (ASN)"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  v-model="receipt_no"
                  label="External Reference No"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  hide-no-data
                  item-text="text"
                  item-value="value"
                  label="Status"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col
                cols="12"
                class="pr-4"
                :sm="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                    ? 12
                    : 3
                "
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>

      <template v-slot:[`item.client_id__name`]="{ item }">
        {{ item.client_id__name }}<br />({{ item.storer_key }})
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at"
          >{{
            item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}
          <br />
          ({{ item.created_by__name }})</span
        >
      </template>

      <template v-slot:[`item.rsa_approved_at`]="{ item }">
        <span v-if="item.rsa_approved_at"
          >{{
            item.rsa_approved_at
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}
          <br />
          ({{ item.rsa_approved_by__name }})</span
        >
      </template>
      <template v-slot:[`item.receipt_key`]="{ item }">
        <a v-if="checkPermission('app_infor:infor_v1_inbound_list')"
          ><span @click="gotodetailsinbound(item)">{{
            item.receipt_key
          }}</span></a
        ><span v-else>{{ item.receipt_key }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          v-if="
            item.status == 'RSA Approval Pending' ||
            item.status == 'Client Approval Pending'
          "
          class=""
          color="warning"
          text-color="white"
          small
          >{{ item.status }}</v-chip
        >
        <v-chip
          v-else-if="
            item.status == 'Client Approved' || item.status == 'RSA Approved'
          "
          class=""
          color="success"
          text-color="white"
          small
          >{{ item.status }}</v-chip
        >
        <v-chip
          v-else-if="
            item.status == 'RSA Rejected' ||
            item.status == 'Client Rejected' ||
            item.status == 'Reopen Failed/System Error'
          "
          class=""
          color="error"
          text-color="white"
          small
          >{{ item.status }}</v-chip
        >
        <v-chip
          v-else-if="item.status == 'Reopen failed/ASN verified closed'"
          class=""
          color="indigo"
          text-color="white"
          small
          >{{ item.status }}</v-chip
        >
      </template>
      <template v-slot:[`item.client_approved_at`]="{ item }">
        <span v-if="item.client_approved_at"
          >{{
            item.client_approved_at
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}
          <br />
          ({{ item.client_approved_by__name }})</span
        >
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_infor:b2b_inbound_asn_reopen_edit')"
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2" v-on="on" @click="findSummary(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Update Request</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    client_statuses: [
      { text: "Pending", value: 0 },
      { text: "Approved", value: 1 },
      { text: "Rejected", value: 2 },
    ],
    statuses: [
      { text: "RSA Approval Pending", value: 0 },
      { text: "RSA Approved", value: 1 },
      { text: "Client Approval Pending", value: 2 },
      { text: "RSA Rejected", value: 3 },
      { text: "Client Approved", value: 4 },
      { text: "Client Rejected", value: 5 },
      { text: "Reopen failed/ASN verified closed", value: 6 },
      { text: "Reopen Failed/System Error", value: 7 },
    ],
    infor_storer_id: null,
    to_date: null,
    from_date: null,
    dateMenu: false,
    dateMenuTo: false,
    summary: false,
    receipt_key_display: null,
    receipt_no: null,
    client_status: null,
    orderDetails: [],

    status: "",
    headers: [
      {
        text: "Client Name (Storer)",
        value: "client_id__name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Warehouse",
        value: "warehouse_id__name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Receipt No (ASN)",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "External Reference Number",
        value: "external_reference_number",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Reason",
        value: "reason_to_reopen",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Comment",
        value: "comments",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Requested At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Approved At (By)",
        value: "rsa_approved_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 150,
        sortable: false,
      },
      {
        text: "Client Approved At (By)",
        value: "client_approved_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 150,
        sortable: false,
      },
      {
        text: "Action",
        value: "actions",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
    ],
    requestOrder: [],
    options: {},
    total: 0,
    warehouse_id: null,

    clients: [],
    selectedClient: null,
    filtersArr: {},
    stores: [],
    warehouses: [],
    tableDetailsItems: [],
    dialog: false,
    getExternalReferenceNumbers: [],
    receiptNumbers: [],
  }),

  watch: {
    options: {
      handler() {
        this.getlist();
      },
      deep: true,
    },
  },
  created() {
    this.getwarehouse();

    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getReceiptNumberList",
      "getRequestOrderBBList",
      "fetchClient",
      "requestStatus",
      "getChannelDropdown",
      "getWarehouseStores",
      "getInforWarehouseList",
      "requestCancel",
    ]),
    getExternalReferenceNumber() {
      this.getExternalReferenceNumbers = this.receiptNumbers.find(
        (item) => item.receipt_key == this.receipt_key_display
      )?.receipt_no;
    },
    confirmation(item) {
      this.removeItem = item;
      this.dialog = true;
    },
    listPage() {
      this.$router.push({
        name: "requestorderStatusList",
        params: {
          type: "request_upload",
        },
      });
    },

    getReceiptNumber() {
      if (this.selectedClient && this.warehouse_id && this.infor_storer_id) {
        let payload = {
          client_id: this.selectedClient,
          warehouse_id: this.warehouse_id,
          channel_id: this.infor_storer_id,
        };
        this.getReceiptNumberList(payload).then((response) => {
          this.receiptNumbers = response.data;
        });
      }
    },
    gotodetailsinbound(item) {
      window.open(
        this.$router.resolve({
          name: "InboundList",
          query: {
            key: item.receipt_key,
            id: item.client_id_id,
          },
        }).href,
        "_blank"
      );
    },
    getwarehouse() {
      this.storer_key = "";
      this.sku = null;
      this.warehouse_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },

    getStores() {
      let payload = {
        client_id: this.selectedClient,
        warehouse_id: this.warehouse_id,
      };
      if (this.selectedClient && this.warehouse_id) {
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },

    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        receipt_key: this.receipt_key_display
          ? this.receipt_key_display.trim()
          : this.receipt_key_display,
        external_reference_number: this.receipt_no
          ? this.receipt_no.trim()
          : this.receipt_no,
        status: this.status,
        client_approved_status: this.client_status,
        start_date: this.from_date,
        end_date: this.to_date,
        channel_id: this.infor_storer_id,
        warehouse_id: this.warehouse_id,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    clearAll() {
      this.receipt_key_display = "";
      this.selectedClient = "";
      this.receipt_no = "";
      this.status = "";
      this.client_status = "";
      this.from_date = null;
      this.to_date = null;
      this.infor_storer_id = null;
      this.warehouse_id = null;
      this.clients = [];
      this.stores = [];
      this.searchAll();
    },

    fetchClientList() {
      this.clients = [];
      this.stores = [];
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          type: "warehouse",
          warehouse_id: this.warehouse_id,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getlist() {
      this.getRequestOrderBBList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.requestOrderLoader = false;
          this.requestOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;
          this.total = res.data.total;
        })
        .catch(() => {
          this.requestOrderLoader = false;
        });
    },

    findSummary(item) {
      this.$router.push({
        path: "/edit-request",
        query: {
          id: item.id,
        },
      });
    },
    tracking(id) {
      this.orderTracking(id).then((res) => {
        this.trackingDetails = res.data.data.records;
        this.reverseData = res.data.data.event_history;
        this.trackingPage = true;
      });
    },

    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getRequestOrderBBList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.requestOrderLoader = false;
          this.requestOrder = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.requestOrderLoader = false;
        });
    },
    gotodetails(item) {
      window.open(
        this.$router.resolve({
          name: "RequestSummary",
          query: {
            key: item.id,
            id: item.client_id,
          },
        }).href,
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 3px 5px 5px !important;
}
</style>
